module.exports = __webpack_public_path__ + "img/laboratorio2_16-9_1920.48ee4aec.webp";